import React from 'react';

export default function VoucherCard({ voucher, onRedeem }) {
  const expiresAt = new Date(voucher.expires_at + 'T00:00:00');
  const today = new Date();
  const daysLeft = Math.ceil((expiresAt - today) / (1000 * 60 * 60 * 24));

  const isExpired = daysLeft <= 0;
  const isUsed = String(voucher.used).toLowerCase() === 'true';

  const overlayClass = isUsed || isExpired
    ? 'bg-gradient-to-t from-black/70 to-black/40 backdrop-blur-[3px]'
    : 'bg-gradient-to-t from-black/30 to-black/10 backdrop-blur-[1px]';

  return (
    <div className="relative w-full max-w-md mx-auto rounded-lg overflow-hidden shadow-lg mb-6">
      <img
        src="/coupon.jpg"
        alt="Voucher"
        className="w-full h-auto object-cover"
      />
      <div className={`absolute inset-0 ${overlayClass} text-white p-4 flex flex-col justify-between rounded-lg`}>
        <div>
          <h2 className="text-2xl font-bold">🎟 {voucher.code}</h2>
          <p>Issued: {voucher.issue_date}</p>
          <p>Expires: {voucher.expires_at}</p>
        </div>
        <div>
          {isExpired && (
            <p className="text-red-400 font-semibold">Expired</p>
          )}
          {!isExpired && (
            <p>{daysLeft} day{daysLeft !== 1 ? 's' : ''} left</p>
          )}

          {isUsed && (
            <p className="text-red-400 font-bold">Already used</p>
          )}

          {!isUsed && !isExpired && (
            <button
              className="mt-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded shadow"
              onClick={() => onRedeem(voucher.code)}
            >
              Redeem
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
